module.exports = __webpack_public_path__ + "img/walker-half-right.e58819cb.jpg";